//src/stores/permission.js
import { defineStore } from 'pinia';
import { ref, reactive, computed } from 'vue';

import { getPermission } from '@/service/home';

export const usePermissionStore = defineStore('permission', () => {

  const routeResponseData = ref([]);
  const userPermissionBtn = ref([]);
  const permissionLoaded = ref(false);

  function extractNodeCodes(nodes) {
    let result = [];

    for (const node of nodes) {
      result.push(node.nodeCode);

      if (node.children && node.children.length > 0) {
        const childCodes = extractNodeCodes(node.children);
        result = result.concat(childCodes);
      }
    }

    return result;
  }

  const asyncGetPermission = async () => {
    try {
      const res = await getPermission(); // 获取权限数据
      if (res.success && res.code == 0) {
        console.log('获取权限成功:', res);

        // 设置菜单权限数据
        routeResponseData.value = res.data || [];

        // 提取所有 nodeCode 并设置按钮权限
        const nodeCodeList = extractNodeCodes(res.data || []);
        userPermissionBtn.value = nodeCodeList;
        permissionLoaded.value = true;
      }
      return res?.data || []; // 可选返回值
    } catch (error) {
      console.error('获取权限失败:', error);
      throw error;
    }
  };

  return {
    asyncGetPermission,
    routeResponseData,
    userPermissionBtn,
    permissionLoaded,
  };
});
